import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { loadScript } from 'ThreeTerminal_base/base';

class lottieAnimation extends React.PureComponent {
    static propTypes = {
        getLoadAnimation: PropTypes.func,
    };

    lottieRef = React.createRef();

    async componentDidMount() {
        await loadScript('https://x0.ifengimg.com/fe/custom/2024_09_25/lottie.min.23054590142f.js', { reload: false });

        const animation = window.lottie.loadAnimation({
            container: this.lottieRef.current,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: window.lottieAnimationJson
        });

        this.props.getLoadAnimation(animation);
    }

    render() {

        return (
            <div className={styles.lottieAnimationBox}>
                <div className={styles.lottieAnimation} ref={this.lottieRef} />
            </div>
        );
    }
}

export default errorBoundary(lottieAnimation);
